import React, { Component } from "react";
import { languages } from "../../constants/languages";
import { languageNames } from "../../constants/languages";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";

class LanguageElement extends Component {
  state = {
    anchorEl: null,
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  changeLanguage = (lang) => {
    let tournamentLang = this.props.tournamentLang;
    if (this.props.index === undefined) {
      tournamentLang.push(lang);
    } else if (lang === "remove") {
      tournamentLang.splice(this.props.index, 1);
    } else {
      tournamentLang[this.props.index] = lang;
    }
    let toUpdate = {};
    toUpdate["lang"] = tournamentLang;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
    this.handleClose();
  };

  render() {
    return (
      <div>
        {this.props.index === undefined ? (
          <Fab
            size="small"
            aria-label="add"
            style={{
              backgroundColor: "white",
              boxShadow: "none",
              border: "1px solid rgba(0, 0, 0, 0.23)",
            }}
            onClick={this.handleMenu}
          >
            <AddIcon />
          </Fab>
        ) : (
          <span
            onClick={this.handleMenu}
            className={
              "flag-icon flag-icon-" +
              (this.props.lang === "en" ? "gb" : this.props.lang) +
              " flag-icon-squared"
            }
            style={{
              width: "40px",
              lineHeight: "40px",
              height: 40,
              borderRadius: "50%",
              cursor: "pointer",
              marginRight: 10,
              boxShadow: "inset 0 2px 4px 0 hsla(0, 0%, 0%, .4)",
            }}
          ></span>
        )}
        <Menu
          id="menu-appbar"
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
          style={{ zIndex: 1302 }}
        >
          {this.props.index !== undefined &&
            this.props.tournamentLang.length > 1 && (
              <MenuItem
                onClick={() => {
                  this.changeLanguage("remove");
                }}
              >
                <i>{languages.general.delete}</i>
              </MenuItem>
            )}
          {languages.getAvailableLanguages().map((lang) => {
            return (
              <MenuItem
                key={lang}
                onClick={() => {
                  this.changeLanguage(lang);
                }}
                disabled={this.props.tournamentLang.indexOf(lang) !== -1}
              >
                {languageNames[lang] || ""}
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    );
  }
}

export default LanguageElement;
